import React from 'react';
import moment from 'moment/moment';

import { AutoCompleteField, MCButton, SelectField, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import { addressObject, lang, remCss } from 'src/helpers';

import constants from 'src/constants';
import { DateSelects } from 'src/components/complex';

import { STEPS } from './constants';
import LANG_CONST from 'src/helpers/lang/const';
import { FormRow } from 'components/Form';
const apiStateId = 'savePatient';

export class AddPatientDetail extends BaseComponent {
  get model() {
    return this.props.model;
  }

  get accountModel() {
    return this.props.accountModel;
  }

  get config() {
    return this.props.config;
  }

  componentDidMount() {
    this.model.subscribe(this.subscription);
    this.accountModel.subscribe(this.subscription);
  }

  componentWillUnmount() {
    this.model.unsubscribe(this.subscription);
    this.accountModel.unsubscribe(this.subscription);
  }

  onNext = (e) => {
    e.preventDefault();

    this.accountModel.savePatient((patient) => {
      if (patient) {
        this.props.loadBeforeSlotStep(patient).then();
      }
    });
  };

  onChange = (n, v) => {
    this.accountModel.resetApiState(apiStateId);
    this.accountModel.handleChange(n, v);
  };

  render = () => {
    const { invalid } = this.accountModel.getApiState(apiStateId);
    const loading =
      this.accountModel.getApiState(apiStateId).loading ||
      this.model.getApiState('getSlots').loading ||
      this.model.getApiState('doctorDetail').loading;

    const addressObj = addressObject(this.accountModel.state);

    const active = this.model.state.step === STEPS.ADD_PATIENT_DETAIL;

    return (
      <div className={'mc-tab-content ' + (active ? '' : 'mc-inactive')}>
        {active && (
          <div className={'mc-flex-20-col mc-grow'}>
            <FormRow>
              <TextField
                template={6}
                label={LANG_CONST.first_name}
                name={'firstName'}
                value={this.accountModel.state.firstName}
                onChange={this.onChange}
                invalid={invalid}
                placeholder={LANG_CONST.enter_patient_first_name}
              />
              <TextField
                template={6}
                label={LANG_CONST.last_name}
                name={'lastName'}
                value={this.accountModel.state.lastName}
                placeholder={LANG_CONST.enter_patient_last_name}
                onChange={this.onChange}
                invalid={invalid}
              />
            </FormRow>
            <FormRow>
              <TextField
                template={6}
                label={'Email Address'}
                name={'email'}
                value={this.accountModel.state.email}
                placeholder={'Enter patient email address'}
                onChange={this.onChange}
                invalid={invalid}
              />
              <SelectField
                template={6}
                width={'100%'}
                options={constants.general.gender}
                label={'Gender'}
                name={'gender'}
                value={this.accountModel.state.gender}
                onChange={this.onChange}
                invalid={invalid}
              />
            </FormRow>
            <div className={'mc-flex-col'}>
              <div className={'mc-label-418'}>{lang.t(LANG_CONST.birthday)}</div>
              <FormRow>
                {this.model.state.step === STEPS.ADD_PATIENT_DETAIL && (
                  <DateSelects
                    close={true}
                    className={'mc-flex-20'}
                    template={6}
                    minDate={moment().startOf('year').year(1900)}
                    maxDate={moment().add({ years: -14 }).endOf('year')}
                    onChange={(n, v) => this.onChange(n, v)}
                    invalid={invalid}
                    name={'birthday'}
                    date={this.accountModel.state.birthday}
                  />
                )}
              </FormRow>

              {invalid['birthday'] && <p className='mc-form-invalid-text'>{invalid['birthday']}</p>}
            </div>
            <div className={'mc-value-620'}>{lang.t('Address')}</div>

            <FormRow>
              <TextField
                template={6}
                label={LANG_CONST.address.address_line}
                name={'address'}
                placeholder={''}
                value={this.accountModel.state.address}
                onChange={this.onChange}
                invalid={invalid}
              />
            </FormRow>
            <FormRow>
              <AutoCompleteField
                template={6}
                label={'Country'}
                name={'countryAddress'}
                value={this.accountModel.state.countryAddress}
                onChange={(n, v) => {
                  if (this.accountModel.state.countryAddress !== v) {
                    this.onChange(n, v);
                    this.onChange('stateAddress', '');
                    this.onChange('cityAddress', '');
                  }
                }}
                autocompleteApi='country'
                autocompleteParams={{
                  limit: 300
                }}
                invalid={invalid}
              />
              <AutoCompleteField
                template={6}
                label={'State'}
                name={'stateAddress'}
                value={this.accountModel.state.stateAddress}
                onChange={(n, v) => {
                  this.onChange(n, v);
                  this.onChange('cityAddress', '');
                }}
                invalid={invalid}
                autocompleteParams={{
                  countryCode: addressObj.countryCode,
                  limit: 100
                }}
                autocompleteApi='state'
              />
              <AutoCompleteField
                template={6}
                label={'City'}
                name={'cityAddress'}
                value={this.accountModel.state.cityAddress}
                onChange={(n, v) => {
                  this.onChange(n, v);
                }}
                invalid={invalid}
                autocompleteApi='city'
                autocompleteParams={{
                  countryCode: addressObj.countryCode,
                  stateCode: addressObj.stateCode,
                  limit: 20
                }}
              />
            </FormRow>
            <FormRow addColspan={2}>
              <TextField
                template={6}
                label={'Postal code'}
                name={'zipcode'}
                value={this.accountModel.state.zipcode}
                onChange={this.onChange}
                invalid={invalid}
              />
            </FormRow>
          </div>
        )}
        <div className={'mc-flex-20'}>
          <MCButton
            light
            primary
            radius
            medium
            disabled={loading}
            onClick={(e) => {
              e.preventDefault();
              this.model.previousStep();
            }}
            style={{ width: remCss(100) }}
            label={LANG_CONST.buttons.back}
          />
          <div className={'mc-grow'} />
          <MCButton
            primary
            medium
            radius
            light
            style={{ width: remCss(100) }}
            label={LANG_CONST.buttons.cancel}
            disabled={loading}
            onClick={this.props.onBack}
          />
          <MCButton
            primary
            medium
            radius
            dark
            label={LANG_CONST.buttons.next}
            style={{ width: remCss(100) }}
            disabled={loading}
            loading={loading}
            onClick={this.onNext}
          />
        </div>
      </div>
    );
  };
}
